<div
  bsModal
  #mySettingsModal="bs-modal"
  (onShown)="onShown()"
  class="modal fade"
  tabindex="-1"
  role="dialog"
  aria-labelledby="myLargeModalLabel"
  aria-hidden="true"
  [config]="{ backdrop: 'static' }"
>
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <form autocomplete="off" *ngIf="active" #mySettingsModalForm="ngForm" (ngSubmit)="save()">
        <div class="modal-header">
          <h5 class="modal-title">
            <span>{{ 'MySettings' | localize }}</span>
          </h5>
          <button type="button" class="close" [attr.aria-label]="l('Close')" (click)="close()">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body" *ngIf="user">
          <tabset class="tab-container tabbable-line">
            <tab heading="{{ 'Profile' | localize }}" customClass="m-tabs__item">
              <div class="form-group">
                <label for="Name">{{ 'Name' | localize }} *</label>
                <input
                  id="Name"
                  #nameInput="ngModel"
                  class="form-control"
                  type="text"
                  name="Name"
                  [(ngModel)]="user.name"
                  required
                  maxlength="32"
                />
                <validation-messages [formCtrl]="nameInput"></validation-messages>
              </div>

              <div class="form-group">
                <label for="Surname">{{ 'Surname' | localize }} *</label>
                <input
                  id="Surname"
                  #surnameInput="ngModel"
                  type="text"
                  name="Surname"
                  class="form-control"
                  [(ngModel)]="user.surname"
                  required
                  maxlength="32"
                />
                <validation-messages [formCtrl]="surnameInput"></validation-messages>
              </div>

              <div class="form-group">
                <label for="EmailAddress">{{ 'EmailAddress' | localize }} *</label>
                <input
                  id="EmailAddress"
                  #emailAddressInput="ngModel"
                  type="email"
                  name="EmailAddress"
                  class="form-control"
                  [(ngModel)]="user.emailAddress"
                  required
                  email
                  maxlength="256"
                />
                <validation-messages [formCtrl]="emailAddressInput"></validation-messages>
              </div>
            </tab>
          </tabset>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" (click)="close()" [disabled]="saving">{{ 'Cancel' | localize }}</button>
          <button type="submit" class="btn btn-primary" [disabled]="!mySettingsModalForm.form.valid || saving">
            <i class="fa fa-save"></i> <span>{{ 'Save' | localize }}</span>
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
